import React from "react";
// ANT DESIGN COMPONENTS
import { Button } from "antd";
// I18N TRANSLATION
import { useTranslation } from "react-i18next";
// REDUX
import { useDispatch } from "react-redux";
import { updateShowTable } from "../../../redux/messageType/messagesTypeSlice";

function MessageTypeHeader() {
	// ************************************************ */
	// GLOBAL VARIABLES ******************************* */
	const dispatch = useDispatch();
	const [t] = useTranslation("global");

	// ************************************************ */
	// USE STATE VARIABLES **************************** */

	// ************************************************ */
	// REDUX SLICE VARIABLES ************************** */

	// ************************************************ */
	// SERVICES AND API CALLS ************************* */

	// ************************************************ */
	// FUNCTIONS ************************************** */

	return (
		<div className='generalStyles__spaceBetween'>
			<div className='generalStyles__mlFix mt-1'>
				<Button
					className='buttonStyle__9'
					onClick={() => {
						dispatch(updateShowTable(false));
					}}
				>
					{t("configuration.cancel")}
				</Button>
			</div>
		</div>
	);
}

export default MessageTypeHeader;
